import { Injectable } from "@angular/core";
@Injectable()
export class LoginModel{
    Email: String;
    Password: String;
}